`<template>
  <div :class="classes">
    <pt-page-title :title="historyTitle"></pt-page-title>
    <div v-if="isShowTopMenusFilter">
      <pt-page-menu-filter :tabs="typeTabs" v-model="selectTab" state="name" :class="$style.menufilter" :isRouteQuery="true"></pt-page-menu-filter>
    </div>
    <pt-export-history-table :tableLabels="tableLabels" :page-size="pageSize" :queryName="queryName" :routerName="routerName">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.state==='STORED'" @click="download(scope.row)">下载</el-button>
        </template>
      </el-table-column>
    </pt-export-history-table>
  </div>
</template>

<script>
// 组件class前缀
import ptExportHistoryTable from './pt-export-history-table/withData'
import { historyTableLabels } from './export-history-option'
const prefixCls = 'pt-export-history'
export default {
  name: 'pt-export-history',
  components: {
    ptExportHistoryTable
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    historyTitle () {
      let pageName
      switch (this.routerName) {
        case 'export-history':
          switch (this.queryName) {
            case 'mall_order_export':pageName = '订单导出历史'
              break
            case 'points_order_export':pageName = '兑换记录导出历史'
              break
            case 'refund':pageName = '退款订单导出历史'
              break
            case 'lab_export':pageName = '实验室订单导出历史'
              break
            case 'mall_order_bill':pageName = 'CPS缴费记录导出历史'
              break
            case 'doctor':pageName = '医生二维码导出历史'
              break
            case 'doctor_user_export':pageName = '医生列表导出历史'
              break
            case 'deposit_audit_export':pageName = '订金结算导出历史'
              break
            case 'points_details_export':pageName = '积分明细导出历史'
              break
            default:pageName = null
          }
          break
        case 'export-history-new':pageName = '脐荐康记录导出历史'
          break
        case 'export-history-new-audit':pageName = '脐荐康奖励记录导出历史'
          break
        case 'adult_lab_order':pageName = '成人实验室订单导出历史'
          break
        case 'export-withdraw-audit':pageName = '提现导出历史'
          break
        case 'export-fast-loan-audit':pageName = '银行分期返惠导出历史'
          break
        case 'export-history-customer':pageName = '生命银行用户导出历史'
          break
        case 'export-history-sign':pageName = '报名/问卷记录导出历史'
          break
        case 'export-history-all-audit':pageName = '奖励汇总导出历史'
          break
        case 'doctor-qr-code-history':pageName = '医生导出历史'
          break
        case 'export-history-manual-reward':pageName = '手动发放奖励导出历史'
          break
        case 'export-history-points-reward':pageName = '积分发放导出历史'
          break
        case 'export-history-star-salesman':pageName = '星荐官奖励导出历史'
          break
        case 'doctor_invite_reward_export':pageName = '河北医护活动导出历史'
          break
        case 'pay_order_export':pageName = '扫码缴费记录导出历史'
          break
        case 'export-history-insure':pageName = '投保信息导出历史'
          break
        case 'export-history-batch':pageName = '跑批异常日志导出历史'
          break
        case 'counselor-qr-code':pageName = '导出历史'
          break
        case 'export-history-scan-payment-counselor':pageName = '生命银行扫码支付导出历史'
          break
        case 'export-history-scan-payment-life-experience-hall':pageName = '生命体验馆扫码支付导出历史'
          break
        case 'export-history-scan-payment-storage':pageName = '静态码收款业务导出历史'
          break
        case 'reservation-export':pageName = '生命体验馆预约导出历史'
          break
        case 'reservation-invoice-export': pageName = '生命体验馆预约发票导出历史'
          break
        default:pageName = null
      }
      return pageName
    //   return this.queryName === 'order' ? '订单导出历史' : (this.queryName === 'refund' ? '退款订单导出历史' : 'null')
    },
    service () {
      let service
      switch (this.routerName) {
        case 'adult_lab_order':service = 'adultlab'
          break
        case 'export-history':
          switch (this.queryName) {
            case 'lab_export':service = 'lab'
              break
            case 'points_order_export':service = 'points'
              break
            case 'points_details_export':service = 'members'
              break
            default:service = 'mallsales'
          }
          break
        case 'export-history-customer':
          service = 'uaa'
          break
        case 'doctor-qr-code-history':
          service = 'uaa'
          break
        case 'counselor-qr-code':
          service = 'uaa'
          break
        case 'pay_order_export':
          service = 'pay'
          break
        case 'export-history-insure' :
        case 'export-history-batch':
          service = 'formerop'
          break
        default:service = 'mallsales'
      }
      return service
    },
    doctorQueries () {
      return ['doctor', 'doctor_user_export']
    },
    counselorQueries () {
      return ['counselor_user_zip_export', 'counselor_user_export']
    },
    isShowTopMenusFilter () {
      return this.routerName === 'doctor-qr-code-history' || this.routerName === 'counselor-qr-code'
    },
    typeTabs () {
      if (this.counselorQueries.includes(this.queryName)) {
        return [{
          label: '咨询师付款码导出历史',
          value: 'counselor_user_zip_export'
        },
        {
          label: '咨询师导出',
          value: 'counselor_user_export'
        }]
      }
      return [
        {
          label: '医生二维码导出历史',
          value: 'doctor'
        },
        {
          label: '医生列表导出历史',
          value: 'doctor_user_export'
        }
      ]
    }
  },
  data () {
    return {
      tableLabels: historyTableLabels,
      pageSize: 10,
      queryName: '',
      routerName: '',
      selectTab: ''
    }
  },
  watch: {
    selectTab (val) {
      console.log('------selectTab----', val)
      this.queryName = val
    }
  },
  methods: {
    download (row) {
      location.href = `${this.$apiServer}/${this.service}/api/user/oss/items/download/${row.id}`
    }
  },
  created () {
    this.queryName = this.$route.query.name
    this.routerName = this.$route.name
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
